export enum LoanOfficerPage {
  OfficerList = 'officerlist',
  AppList = 'applist',
  AvailableList = 'loanofficerlistavailable',
}

export enum LoanOfficerServiceErrorCode {
  GENERAL,
}

export interface LoanOfficerFailure {
  message: string
}

interface LoanOfficer {
  ID: number
  Active: 1 | 0
  CatID: number
  DisableDate: string
  FullName: string
  LoginFull: string
  Manager_Category: string
  Node: string
  Regdate: string
  SEC_UserID: number
  User_Name: string
}

export type LoanOfficersServerData = LoanOfficer[]

interface AppOfficer {
  ID: number
  FullName: string
}

export type AppOfficersServerData = AppOfficer[]
